export default "__VITE_ASSET__COc7xU0p__"